import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@mui/material";
import s from "./DefaultDataTable.module.scss";
import NoResult from "components/Datatable/NoResult/NoResult";

const renderTableContent = (records) => {
  return (
    <div className={s.dataTableContainer}>
      <TableContainer>
        <Table className={s.dataTable}>
          <TableHead>
            <TableRow>
              {Object.keys(records[0]).map((header, headerIdx) => (
                <TableCell className={s.tableHeader} key={headerIdx}>
                  {parseHeader(header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {records.map((item, rowIndex) => (
              <TableRow key={rowIndex}>
                {Object.values(item).map((col, colIndex) => (
                  <TableCell className={s.tableCell} key={colIndex}>
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const parseHeader = (str) => {
  if (str.length === 0) {
    return str;
  }

  const snakeRegex = new RegExp(/[a-zA-Z0-9\_\S]/, "ig");

  if (snakeRegex.test(str)) {
    const wordArray = str.split("_");
    const newWords = wordArray.map((word) => {
      return word.substring(0, 1).toUpperCase() + word.substring(1);
    });

    return newWords.join(" ");
  }

  return str
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([a-zA-Z])(\d+)/g, "$1 $2")
    .replace(/(\d+)([a-zA-Z])/g, "$1 $2");
};

const DefaultDataTable = (props) => {
  const { records } = props;

  if (!records?.length) {
    return <NoResult width="100%" />;
  }

  return <>{renderTableContent(records)}</>;
};

export default React.memo(DefaultDataTable);
